import { invalidateLabelCatalog } from "./label";
import { invalidateLabelCategories } from "./labelCategory";
import { invalidateTrainingEvalCatalogs } from "./trainingEval";
import { invalidateScopedPolicyCatalog } from "./trainingPolicies";

// 세션 수명 캐시의 단일 초기화 진입점.
//
// 로그아웃·원격 로그아웃·사용자 전환처럼 세션 경계가 바뀌면 앱은 이 함수 하나만 부른다.
// 이 경계가 있으면 카탈로그를 추가할 때 호출부를 찾아 고치지 않아도 된다.
// rules.md §6 에 따라 정책의 source of truth 는 한 곳이다.

// page 계층이 소유한 세션 캐시를 여기에 등록한다. api 가 page 를 import 하면 계층 방향이
// 반대가 된다. 그래서 캐시 소유자가 자기 초기화 함수를 등록한다.
const registeredResets = new Set<() => void>();

export function registerSessionCacheReset(reset: () => void): () => void {
  registeredResets.add(reset);
  return () => registeredResets.delete(reset);
}

export function resetSessionCatalogs(): void {
  invalidateLabelCatalog();
  invalidateLabelCategories();
  invalidateTrainingEvalCatalogs();
  invalidateScopedPolicyCatalog();
  for (const reset of registeredResets) {
    reset();
  }
}
